<template>
  <div class="home">
    <FilterLayout v-model="searchForm" @onSubmit="onSubmit">
      <el-col :md="6" :sm="12">
        <el-form-item label="名称:" prop="title">
          <el-input v-model.trim="searchForm.title" placeholder="请输入SDK名称" />
        </el-form-item>
      </el-col>

      <el-col :md="6" :sm="12">
        <el-form-item label="采集方式:" prop="collect_type">
          <el-select v-model="searchForm.collect_type" placeholder="请选择">
            <el-option label="全部" value=""> </el-option>
            <el-option v-for="item in collectType" :key="item.id" :label="item.label" :value="item.val">
            </el-option>
          </el-select>
        </el-form-item>
      </el-col>

      <el-col :md="6" :sm="12">
        <el-form-item label="使用场景:" prop="use_scene">
          <el-input v-model.trim="searchForm.use_scene" placeholder="请输入使用场景" />
        </el-form-item>
      </el-col>

      <el-col :md="6" :sm="12">
        <el-form-item label="合作方主体:" prop="company_subject">
          <el-input v-model.trim="searchForm.company_subject" placeholder="请输入合作方主体" />
        </el-form-item>
      </el-col>

      <el-col :md="6" :sm="12">
        <el-form-item label="SDK引用APP:" prop="app_ids">
          <SelectCustomizeNew :value.sync="appidInfo" :data="apps" @changeScope="changeAppid" />
        </el-form-item>
      </el-col>

      <el-button @click="initFrom" slot="btn-option">重置筛选</el-button>
    </FilterLayout>
    <TableLayout :column="column" :data="tableData.data" :total="tableData.total" :loading="tableData.loading"
      :currentPage="tableOpt.currentPage" :params="searchForm" @sizeChange="onSizeChange" @pageChange="onPageChange"
      @sortChange="onSortChange" :tooltipFlag="true" alignStyle="center" :defaultSort="sort">
      <template #table-option>
        <el-button type="primary" @click="goAdd(editData)">新增SDK信息</el-button>
      </template>
      <!-- 添加时间 -->
      <template #create_time="{ row }">
        <div>
          {{ moment(row.create_time * 1000).format("YYYY-MM-DD HH:mm:ss") }}
        </div>
      </template>
      <!-- 合作方隐私链接 -->
      <template #secrecy_link="{ row }">
        <div>
          <el-link :underline="false" type="primary" @click="goH5(row.secrecy_link)">{{ row.secrecy_link }}</el-link>
        </div>
      </template>
      <!-- 合作方官网链接 -->
      <template #official_link="{ row }">
        <div>
          <el-link :underline="false" type="primary" @click="goH5(row.official_link)">{{ row.official_link }}</el-link>
        </div>
      </template>
      <template #app_names="{ row }">
        <div v-if="row.app_names && row.app_names.length <= 3">
          <div v-for="(item, index) in row.app_names" :key="index">
            {{ formatSystem(item.system, item.title) }}
          </div>
        </div>
        <div v-if="row.app_names && row.app_names.length > 3">
          <el-tooltip class="item" effect="dark" placement="top-start">
            <div slot="content">
              <div v-for="(item, index) in row.app_names" :key="index" style="margin-bottom: 4px">
                {{ formatSystem(item.system, item.title) }}
              </div>
            </div>
            <el-button type="text">显示详情</el-button>
          </el-tooltip>
        </div>
      </template>
      <!-- 操作 -->
      <template #operate="scope">
        <div>
          <el-button type="text" size="small" @click="delData(scope.row)">删除</el-button>
          <el-button type="text" size="small" @click="goEdit(scope.row)">修改</el-button>
        </div>
      </template>
    </TableLayout>
  </div>
</template>

<script>
import { goNewSys } from '@/util/index'
import moment from "moment";
import store from "store2";
import FilterLayout from "@/layout/form";
import TableLayout from "@/layout/table";
import SelectCustomizeNew from "@/component/select-customize-new";
import { mapState } from "vuex";
import { formatSystem } from "@/util/filters";

export default {
  title: "home",
  components: {
    FilterLayout,
    TableLayout,
    SelectCustomizeNew,
  },
  data() {
    return {
      searchForm: {
        title: "", //名称
        collect_type: "", //采集方式
        use_scene: "", //使用场景
        company_subject: "", //合作方主体
        app_ids: [], //应用
      },
      sort: {
        prop: "create_time",
        order: "desc",
      },
      column: [
        {
          prop: "title",
          label: "名称",
        },
        {
          prop: "collect_type",
          label: "采集方式",
        },
        {
          prop: "involve_personal_info",
          label: "涉及个人信息",
        },
        {
          prop: "use_purpose",
          label: "使用目的",
        },
        {
          prop: "use_scene",
          label: "使用场景",
        },
        {
          prop: "company_subject",
          label: "合作方主体",
        },
        {
          prop: "secrecy_link",
          label: "合作方隐私链接",
        },
        {
          prop: "official_link",
          label: "合作方官网链接",
        },
        {
          prop: "app_names",
          label: "SDK引用APP",
        },
        {
          prop: "create_time",
          label: "添加时间",
          width: "150",
          sortable: "custom",
        },
        {
          prop: "operate",
          label: "操作",
        },
      ],
      tableOpt: {
        currentPage: 1,
        pageSize: 10,
      },
      // 表格数据
      tableData: {
        loading: false,
      },
      apps: [],
      appidInfo: {
        appInfo: [], //应用-组件列表数据
      },
      gather_type: [
        {
          value: "选项1",
          label: "黄金糕",
        },
        {
          value: "选项2",
          label: "双皮奶",
        },
      ],
      moment: moment,
    };
  },
  mounted() {
    // 跳转新的系统
    goNewSys({
      path: "/manage/other/sdk_manage"
    })
    return;
    // 初始化调用事业群分组
    this.getRoleBtree();
    // 调用列表接口
    this.getReport();
  },
  computed: {
    ...mapState({
      collectType: (state) => state.dict_main.collect_type,
    }),
  },
  methods: {
    formatSystem,
    onSubmit() {
      this.tableOpt.currentPage = 1;
      this.getReport();
    },
    // 链接跳转
    goH5(url) {
      window.open(url, "_blank");
    },
    // 获取app事业群分组
    async getRoleBtree() {
      const [err, res] = await this.$http.post("System/roleBtree");
      if (err) return;
      console.log(res);
      res.list.forEach((item) => {
        if (item.title == "应用") {
          item.node.forEach((_item) => {
            if (_item.system == "1") {
              _item.title = _item.title + "_Android";
            } else if (_item.system == "2") {
              _item.title = _item.title + "_IOS";
            } else if (_item.system == "3") {
              _item.title = _item.title + "_微信小程序";
            }
          });
        }
      });
      let apps = [];
      let article_id_arr = [];
      res.tree.forEach((item) => {
        item.node.forEach((_item) => {
          article_id_arr.push(..._item.node);
          _item.node.forEach((__item) => {
            apps.push(...__item.node);
          });
        });
      });
      this.apps = apps;
    },
    // 获取列表
    async getReport() {
      this.tableData.loading = true;
      const { searchForm, tableOpt, sort } = this;
      const [err, res] = await this.$http.post("Other/externalSdkList", {
        ...searchForm,
        ...tableOpt,
        ...sort,
        app_ids: this.appidInfo.appInfo,
      });
      this.tableData.loading = false;
      if (err) {
        this.tableData = {
          list: [],
          total: 0,
          currentPage: 1,
          pageSize: 10,
          loading: false,
        };
        return;
      }
      const { list, currentPage, total } = res;
      this.tableData.data = list;
      this.tableData.currentPage = currentPage;
      this.tableData.total = total;
    },
    onPageChange(current) {
      this.tableOpt.currentPage = current;
      this.getReport();
    },
    onSizeChange(current) {
      this.tableOpt.pageSize = current;
      this.getReport();
    },
    // 获取事件列表
    async getEventList() {
      const [err, res] = await this.$http.post("event_conf/list");
      if (err) return;
      this.event_options = res.list;
    },
    // 删除
    delData(data) {
      this.$confirm("确认删除当前SDK？").then(async (_) => {
        this.tableData.loading = true;
        const [err, res] = await this.$http.post("Other/externalSdkDelete", {
          id: data.id,
        });
        if (err) return;
        this.$message({
          message: "删除成功",
          type: "success",
        });
        this.tableOpt.currentPage = 1;
        this.getReport();
      });
    },
    // 重置表单
    initFrom() {
      this.searchForm = {
        title: "", //名称
        collect_type: "", //采集方式
        use_scene: "", //使用场景
        company_subject: "", //合作方主体
        app_ids: [], //应用
      };
      this.appidInfo = {
        appInfo: [], //应用-组件列表数据
      };
    },
    // 修改
    changeData(data) { },
    // 筛选应用的回调函数
    changeAppid(val) {
      this.searchForm.app_ids = val.appInfo;
    },
    // 跳转新增SDK信息
    goAdd() {
      this.$router.push({
        path: "/manage_center/other/sdk/add",
        query: {
          apps: this.apps,
        },
      });
    },
    // 跳转编辑SDK信息
    goEdit(data) {
      this.$router.push({
        path: "/manage_center/other/sdk/add",
        query: {
          editData: data,
        },
      });
    },
    onSortChange(data) {
      const { prop } = data;
      let order = data.order;
      if (order === "ascending") {
        this.sort.order = "asc";
      }
      if (order === "descending") {
        this.sort.order = "desc";
      }
      this.sort.field = prop;
      this.tableOpt.currentPage = 1;
      this.getReport();
    },
  },
};
</script>

<style lang="less" scoped>
.event_div {
  margin: 10px 0;
}
</style>
